import { render, staticRenderFns } from "./CreateExampleComponent.vue?vue&type=template&id=16f3b221&scoped=true"
import script from "./CreateExampleComponent.vue?vue&type=script&lang=js"
export * from "./CreateExampleComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateExampleComponent.vue?vue&type=style&index=0&id=16f3b221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3b221",
  null
  
)

export default component.exports